
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post-generator",
      function () {
        return require("private-next-pages/post-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post-generator"])
      });
    }
  